import { Barangay, PrefixOption } from '../../types';
import { Box, Paper, Typography } from '@mui/material';

import PrecinctVotersListEntry from './PrecinctVotersListEntry';
import React from 'react';

interface PrecinctVotersListReportProps {
  barangay: Barangay;
  precincts: string[];
  prefixOption?: PrefixOption;
}

const PrecinctVotersListReport: React.FC<PrecinctVotersListReportProps> = ({ 
  barangay, 
  precincts = [],
  prefixOption = 'numbers'
}) => {
  return (
    <Box sx={{ p: 2 }}>
      {precincts.map(precinct => (
        <Paper key={precinct} sx={{ mb: 2, p: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography variant="h5">{barangay.city_municipality.toUpperCase()}</Typography>
            <Typography variant="h6">BARANGAY {barangay.barangay.toUpperCase()}</Typography>
            <Typography variant="h6" gutterBottom>
              PRECINCT {precinct}
            </Typography>
          </Box>
          <Box sx={{ columnCount: 3, columnGap: '20px' }}>
            <PrecinctVotersListEntry 
              barangay={barangay} 
              precinct={precinct} 
              prefixOption={prefixOption}
            />
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default PrecinctVotersListReport;
